import React from 'react'
import clsx from 'clsx'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/utility/react-modal'
import TimelineNode from '../TimelineNode'

const DARK_GREEN = 'var(--dark-green)'
const SAGE = 'var(--sage, #A8CB8F)'

export function SubmissionSuccessModal({
  isOpen,
  labels,
  hasImmediateFees,
  immediateFeesName,
  timelineSteps = [],
  packageHashedId,
  onClose,
}) {
  const sorted = [...timelineSteps].sort((a, b) => a.order - b.order)
  const hasTimeline = sorted.length > 0

  const allNodes = hasTimeline
    ? [
        {
          label: `${labels.processorTag || ''} package submitted`.trim(),
          nodeColor: DARK_GREEN,
          edgeColor: DARK_GREEN,
          textClass: 'dome-p2 dome-color-lite-grey',
        },
        ...sorted.map((step, idx) => ({
          label: step.message,
          nodeColor: idx === sorted.length - 1 ? SAGE : DARK_GREEN,
          edgeColor: idx === sorted.length - 2 ? SAGE : DARK_GREEN,
          textClass: 'dome-p2 dome-color-darkest-grey',
        })),
      ]
    : []

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="submission-modal">
      <ModalHeader>
        <i className="fa-thin fa-circle-check dome-color-dark-green submission-modal-icon" />
        <span className="dome-h2 dome-color-dark-green">submitted to property</span>
      </ModalHeader>

      <ModalBody className="dome-gap18">
        {hasImmediateFees && (
          <div className="dome-d-flex dome-align-baseline dome-gap6 dome-bg-fill dome-rounded-border dome-padding6">
            <i className="fas fa-circle-dollar dome-p3 dome-color-dark-grey" />
            <div className="dome-d-flex dome-flex-column dome-gap6 submission-modal-panel-body">
              <span className="dome-p2 dome-color-dark-grey dome-text-w500">{immediateFeesName ? 'compliance ' : ''}fees collected</span>
              <span className="dome-p3 dome-color-dark-grey">
                A receipt was emailed to cardholder. <br />
                Other authorized fees will be collected by Management.
              </span>
            </div>
          </div>
        )}

        {hasTimeline ? (
          <div className="dome-d-flex dome-flex-column dome-gap12">
            <span className="dome-p1 dome-color-dark-grey">What to expect next:</span>
            <div className="submission-timeline-steps">
              {allNodes.map((node, idx) => (
                <TimelineNode key={idx} {...node} isLast={idx === allNodes.length - 1} />
              ))}
            </div>
          </div>
        ) : (
          <span className="dome-p2 dome-color-dark-grey">
            You have successfully submitted this {labels.processorTag?.toLowerCase()} package to the{' '}
            {labels.processorTag?.toLowerCase()} processor(s) for review.
          </span>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          type="button"
          onClick={onClose}
          className="dome-btn dome-btn-link dome-btn-link-cancel dome-btn-link-med-grey"
        >
          close
        </button>
        {packageHashedId && (
          <a href={`/packages/${packageHashedId}/status`} className="dome-link dome-is-button dome-link-dark-green">
            go to status tab
          </a>
        )}
      </ModalFooter>
    </Modal>
  )
}

export default SubmissionSuccessModal
